import { useEffect, useState } from "react";
import { Button, Card, Col, Form, Modal, Row, Table } from "react-bootstrap";
import DataTable from "datatables.net-react";
import $ from 'jquery';
import { FaFilter } from 'react-icons/fa';
import Select from 'react-select';
import { RejectionLogServices } from "../../services/RejectionLogServices";
import * as BullCache from "../../util/BullCache";
import AdminDropdown from "../components/AdminDropdown";
import BrokerDropdown from "../components/BrokerDropdown";
import ClientDropdown from "../components/ClientDropdown";
import { customStyles, the } from "../components/customStyles";
import From from '../components/From';
import MarketDropdown from "../components/MarketDropdown";
import MasterDropdown from "../components/MasterDropdown";
import ScriptDropdown from "../components/ScriptDropdown";
import To from '../components/To';
import { getTodayDate } from "../../util/Utils"

function MobileRejectionLog() {

    const [loading, setLoading] = useState(false);
    const [logList, setLogList] = useState([]);
    const [selectedAdmin, setSelectedAdmin] = useState(null);
    const [selectedMaster, setSelectedMaster] = useState(null);
    const [selectedBroker, setSelectedBroker] = useState(null);
    const [selectedSubBrokerId, setSelectedSubBrokerId] = useState(null);
    const [selectedClient, setSelectedClient] = useState(null);
    const [selectedMarket, setSelectedMarket] = useState(null);
    const [selectedScript, setSelectedScript] = useState(null);
    const [selectedBrokerId, setSelectedBrokerId] = useState(null);
    const [selectedOrderType, setSelectedOrderType] = useState(null);
    const [fromDate, setFromDate] = useState(getTodayDate());
    const [toDate, setToDate] = useState(getTodayDate());
    const [showModal, setShowModal] = useState(false);
    const handleModalShow = () => setShowModal(true);
    const handleModalClose = () => setShowModal(false);

    var user = BullCache.getFromCache("user");
    var allScripts = BullCache.getFromCache('allScripts');

    const [searchTerm, setSearchTerm] = useState('');  // Added search term state
    const [filteredLogList, setFilteredLogList] = useState([]); // Added filtered log list state

    const handleMarketChange = (market) => {
        setSelectedMarket(market);
    };

    const handleScriptChange = (script) => {
        setSelectedScript(script);
    };
    const handleScriptReset = () => {
        setSelectedScript(null);
    };
    const handleFromDateChange = (newDate) => {
        setFromDate(newDate);  // Update fromDate whenever it changes
    };
    const handleSelectedClientChange = (selected) => {
        setSelectedClient(selected?.userId);
    };
    const handleOrderTypeChange = (selectedOption) => {
        setSelectedOrderType(selectedOption);
    };
    const handleSearchChange = (event) => {
        const value = event.target.value;
        setSearchTerm(value);

        // Filter the logs based on the search term
        if (value) {
            const filteredData = logList.filter((log) => {
                return log.client.toLowerCase().includes(value.toLowerCase()) ||
                    log.script.toLowerCase().includes(value.toLowerCase()) ||
                    log.orderType.toLowerCase().includes(value.toLowerCase());
            });
            setFilteredLogList(filteredData);
        } else {
            setFilteredLogList(logList); // If search is empty, show all logs
        }
    };

    const option = [
        { value: 'market', label: ' Market' },
        { value: 'limit', label: 'Limit' },
    ];

    useEffect(() => {
        const dataToSubmit = {
            adminId: user.adminId,
            date: fromDate,
            endDate: toDate,
            status: "ERROR"
        }
        RejectionLogServices.getTableData(dataToSubmit).then(res => {
            if (res.code === 1) {
                if (res.data.logList.length > 0) {
                    setLogList(res.data.logList);
                    setFilteredLogList(res.data.logList);
                }
            }
        });
    }, []);

    const handleSubmit = () => {
        const dataToSubmit = {
            adminId: user.adminId,
            keyword: selectedScript,
            segment: selectedMarket,
            date: fromDate,
            endDate: toDate,
            status: "ERROR"
        };

        if (selectedClient) {
            dataToSubmit.userId = selectedClient;
            dataToSubmit.adminId = user.adminId;
        } else if (selectedSubBrokerId) {
            dataToSubmit.adminId = selectedSubBrokerId.value;
        } else if (selectedBrokerId) {
            dataToSubmit.adminId = selectedBrokerId;
        } else if (selectedMaster) {
            dataToSubmit.adminId = selectedMaster.value;
        } else if (selectedAdmin) {
            dataToSubmit.adminId = selectedAdmin.value;
        }

        RejectionLogServices.getTableData(dataToSubmit)
            .then((resp) => {
                if (resp.code === 1) {
                    if (resp.data.logList.length > 0) {
                        setLogList(resp.data.logList);
                        setFilteredLogList(resp.data.logList);
                    }
                    else {
                        setLogList([]);
                        setFilteredLogList([]);
                    }
                } else {
                    setLogList([]);
                    setFilteredLogList([]);
                }
            })
            .catch((error) => {
                console.error('Error fetching trade data:', error);
            });
        handleModalClose();
    };
    const handleReset = () => {
        setFromDate('');
        setToDate('');
        setSelectedOrderType('');
        setSelectedMarket('');
        setSelectedScript('');
        setSelectedAdmin('');
        setSelectedMaster('');
        setSelectedBroker('');
        setSelectedClient('');
        setFilteredLogList(logList);
        handleModalClose();
    }

    const columns = [
        { title: 'ACTION', data: 'action' },
        { title: 'CLIENT', data: 'client',className: "text-nowrap"  },
        { title: 'SYMBOL', data: 'script', className: "text-nowrap"  },
        { title: 'ORDER TYPE', data: 'orderType', className: "text-nowrap page-wrapper" },
        { title: 'LOT', data: 'lot' },
        { title: 'QTY', data: 'quantity' },
        { title: 'ORDER PRICE', data: 'rate' },
        { 
            title: 'MESSAGE', 
            data: 'remark', 
            className: "text-nowrap page-wrapper",
            render: function(data, type, row) {
                return data ? data : ''; // Default message when remark is null
            }
        },
        { title: 'O-TIME', data: 'orderTime', className: "text-nowrap" },
        {
          title: 'USER IP',
          render: (data, type, full, meta) => {
            const ip = full.ip;
            if (!ip) return null; 
            return `<a href="https://whatismyipaddress.com/ip/${ip}" target="_blank">${ip}</a>`;
          },
        },
      ];
    

    return (
        <div>
            <Card className="mb-4">
                <Card.Body className="p-0 mb-4">
                    <Row>
                        <Col className="h6 text-start" style={{marginLeft:8, marginTop:8}}>FILTER</Col>

                        <Col className="text-end">
                            <Button variant="link" onClick={handleModalShow}>
                                <FaFilter size={20} />
                            </Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Card className="mt-1 mb-4">
                            <Card.Body className="p-1">
                            <div className="table-responsive">
                                {loading ? (
                                <div className="container vh-100">
                                    <div className="d-flex align-items-center justify-content-center h-90">
                                    <div className="spinner-border text-secondary m-5" role="status" style={{ width: '4rem', height: '4rem' }}>
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                    </div>
                                </div>
                                ) : (
                                <DataTable className=" table table-striped text-center  bg-secondary-row fss-06"
                                    columns={columns} data={logList}
                                    options={{
                                    createdRow: function (row, data) {
                                        if (data.orderType.includes("Buy")) {
                                        $(row).addClass('buy-row');
                                        } else if (data.orderType.includes("Sell")) {
                                        $(row).addClass('sell-row');
                                        }
                                    },
                                    language: {
                                        emptyTable: 'No Data Found',
                                        lengthMenu: '_MENU_',
                                    },
                                    dom: '<"datatable-toolbar"lf>rtip',
                                    }}
                                />
                                )}
                            </div>
                            </Card.Body>
                          </Card>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            {/* Modal Popup */}
            <Modal show={showModal} onHide={handleModalClose} size="sm">
                <Modal.Header closeButton>
                    <Modal.Title>FILTER</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            <b className='fss-05'>FROM DATE</b><br />
                            <From fromDate={fromDate} onDateChange={handleFromDateChange} />
                        </Col>
                        <Col></Col>
                        <Col>
                            <b className='fss-05'>TO DATE</b><br />
                            <To toDate={toDate} setToDate={setToDate} />
                        </Col>
                    </Row>
                    <Row>
                        <b className="fss-05">TYPE</b>
                        <Select
                            options={option}
                            value={selectedOrderType}
                            onChange={handleOrderTypeChange}
                            className='text-black'
                            placeholder="Select"
                            isSearchable={true}
                            theme={the} styles={customStyles}
                            isClearable
                        />
                    </Row>
                    <Row>
                        <b className="fss-05">MARKET</b>
                        <MarketDropdown
                            allScripts={allScripts}
                            onMarketChange={handleMarketChange}
                            onScriptReset={handleScriptReset}
                        />
                    </Row>

                    <Row>
                        <b className="fss-05">SCRIPT NAME</b>
                        <ScriptDropdown
                            allScripts={allScripts}
                            selectedMarket={selectedMarket}
                            onScriptChange={handleScriptChange}
                        />
                    </Row>

                    {(user.adminType === 'SUPER_ADMIN' || user.adminType == 'SUPER_MASTER') && (
                        <Row>
                            <b className="fss-05">ADMIN</b>
                            <AdminDropdown
                                adminId={user.adminId}
                                setSelectedOption={setSelectedAdmin}
                            />
                        </Row>
                    )}

                    {(user.adminType === 'SUPER_ADMIN' || user.adminType === 'ADMIN' || user.adminType == 'SUPER_MASTER') && (
                        <Row>
                            <b className="fss-05">MASTER</b>
                            <MasterDropdown
                                adminId={user.adminId}
                                selectedAdmin={selectedAdmin}
                                setSelectedOption={setSelectedMaster}
                                setSelectedMaster={setSelectedMaster}
                                setSelectedBrokerId={setSelectedBrokerId}
                            />
                        </Row>
                    )}

                    <Row>
                        <b className="fss-05">CLIENT</b>
                        <ClientDropdown
                            selectedAdmin={selectedAdmin}
                            selectedMaster={selectedMaster}
                            selectedBrokerId={selectedBrokerId}
                            selectedSubBrokerId={selectedSubBrokerId}
                            setSelectedOption={handleSelectedClientChange}
                        />
                    </Row>

                    <Row className="mt-2">
                        <Col>
                            <Button variant="success" size="sm" className=" w-50 fss-06 me-4" onClick={handleSubmit}>
                                SEARCH
                            </Button>
                        </Col>
                        <Col className="text-end">
                            <Button variant="danger" size="sm" className="w-50 fss-06" onClick={handleReset}>
                                RESET
                            </Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </div>
    );
}
export default MobileRejectionLog;